import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=ef48a12a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef48a12a')) {
      api.createRecord('ef48a12a', component.options)
    } else {
      api.reload('ef48a12a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=ef48a12a&", function () {
      api.rerender('ef48a12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dHUfjyR7T4PZ/JS/comp/IncreaseNumber.vue"
export default component.exports